import {
    UPDATE_IOS_LAYOUT_SETTINGS_START,
    UPDATE_IOS_LAYOUT_SETTINGS_SUCCESS,
    UPDATE_IOS_LAYOUT_SETTINGS_ERROR,
} from '../../../constants';
import { setLoaderStart, setLoaderComplete } from '../../loader/loader';
import showToaster from '../../../helpers/toasterMessages/showToaster';
import updateIOSSettingsMutation from './updateIOSSettings.graphql';
import getLayoutSettings from './getLayoutSettings.graphql';

export function updateIOSSettings(values) {
    return async (dispatch, getState, { client }) => {
        dispatch({
            type: UPDATE_IOS_LAYOUT_SETTINGS_START,
        });
        dispatch(setLoaderStart('layoutSettings'));
        try {
            const { data } = await client.mutate({
                mutation: updateIOSSettingsMutation,
                variables: {
                    themeType: Number(values.themeType),
                    buttonType: Number(values.buttonType),
                    inputType: Number(values.inputType),
                    onBoardPage: Number(values.onBoardPage),
                    loginPage: Number(values.loginPage),
                    forgotPassword: Number(values.forgotPassword),
                    places: Number(values.places),
                    recommend: Number(values.recommend),
                    banner: Number(values.banner),
                    mostViewed: Number(values.mostViewed),
                    placesOrder: Number(values.placesOrder),
                    recommendOrder: Number(values.recommendOrder),
                    bannerOrder: Number(values.bannerOrder),
                    mostViewedOrder: Number(values.mostViewedOrder),
                    viewCar: Number(values.viewCar),
                    profile: Number(values.profile),
                    wishlist: Number(values.wishlist)
                },
                refetchQueries: [{ query: getLayoutSettings }]
            });
            dispatch(setLoaderComplete('layoutSettings'));
            if (data?.updateIOSSettings?.status == 200) {
                dispatch({ type: UPDATE_IOS_LAYOUT_SETTINGS_SUCCESS });
                showToaster({ messageId: 'updateIOSSettings', toasterType: 'success' })
            }
            else {
                dispatch({ type: UPDATE_IOS_LAYOUT_SETTINGS_ERROR });
                showToaster({ messageId: 'commonError', toasterType: 'error', requestMessage: data?.updateIOSSettings?.errorMessage })
            }
        }
        catch (error) {
            dispatch({ type: UPDATE_IOS_LAYOUT_SETTINGS_ERROR });
            showToaster({ messageId: 'catchError', toasterType: 'error', requestMessage: error })
        }
    }
}
